import { Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React from "react";
import EmployeeCourseTable from "./EmployeeCourseTable";

const IndividualCourseModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleEmployeeClick = (employee) => {
		props.onEmployeeSelected(employee);
	};

	const getEmployeeCourses = () => {
		const employeeCourses = [];
		for (let i in props.course.employeeIds) {
			for (let j in props.companyEmployees) {
				if (props.course.employeeIds[i] === props.companyEmployees[j].id) {
					for (let k in props.companyEmployees[j].courses) {
						if (props.companyEmployees[j].courses[k].course_id === props.course.id) {
							employeeCourses.push({
								employee: props.companyEmployees[j],
								course: props.companyEmployees[j].courses[k]
							});
						}
					}
				}
			}
		}
		return employeeCourses;
	};
	
	return (
		<Dialog
			open={props.course? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="md"
		>
			<DialogTitle id="alert-dialog-title">
				{(props.course)? `${props.course.label}` : ""}
			</DialogTitle>
			<DialogContent>
				{(props.course)?
					<Stack direction="column" spacing={2}>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Not Started:`}</span>
							{`${props.course.employeesNotStarted}`}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Started:`}</span>
							{`${props.course.employeesStarted}`}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Completed:`}</span>
							{`${props.course.employeesCompleted}`}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Retries:`}</span>
							{`${props.course.averageRetries.toFixed(2)}`}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Average Grade:`}</span>
							{`${props.course.averageGrade}`}
						</Typography>
						<Box sx={{ maxHeight: "25em", overflow: "auto" }}>
							<EmployeeCourseTable
								employeeCourses={getEmployeeCourses()}
								onEmployeeClick={handleEmployeeClick}
							/>
						</Box>
					</Stack>
				: <React.Fragment/>
				}
			</DialogContent>
		</Dialog>
	);

}

export default IndividualCourseModal;